interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  color?: string;
  fill?: string;
  strokeWidth?: number;
  ariaLabel?: string;
}

export function Sparkline({
  values,
  width = 120,
  height = 32,
  color = "currentColor",
  fill,
  strokeWidth = 1.5,
  ariaLabel,
}: SparklineProps) {
  const clean = values.filter((v) => Number.isFinite(v)) as number[];
  if (clean.length < 2) {
    return (
      <svg className="sparkline is-empty" viewBox={`0 0 ${width} ${height}`} width={width} height={height} aria-hidden={!ariaLabel} aria-label={ariaLabel}>
        <line x1={0} y1={height - 0.5} x2={width} y2={height - 0.5} stroke="currentColor" strokeOpacity={0.18} strokeWidth={1} />
      </svg>
    );
  }

  const min = Math.min(...clean);
  const max = Math.max(...clean);
  const pad = 2;
  const innerH = height - pad * 2;
  const innerW = width - pad * 2;
  const range = max - min || 1;

  const points = clean.map((v, i) => {
    const x = pad + (i * innerW) / (clean.length - 1);
    const y = pad + innerH - ((v - min) / range) * innerH;
    return [x, y] as const;
  });

  const linePath = points
    .map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`)
    .join(" ");

  const last = points[points.length - 1];
  const first = points[0];
  const fillPath = fill && first && last
    ? `${linePath} L${last[0].toFixed(2)},${(height - pad).toFixed(2)} L${first[0].toFixed(2)},${(height - pad).toFixed(2)} Z`
    : null;

  return (
    <svg
      className="sparkline"
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      height={height}
      preserveAspectRatio="none"
      aria-hidden={!ariaLabel}
      aria-label={ariaLabel}
    >
      {fillPath && <path d={fillPath} fill={fill} opacity={0.18} />}
      <path d={linePath} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
